
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.8 10.963a1 1 0 01-1-1V6.762a.8.8 0 10-1.6 0v4.801a1 1 0 001 1h15.1a1 1 0 001-1V6.762a.8.8 0 00-1.6 0v3.201a1 1 0 01-1 1H2.8z","fill":"#F8F4EE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.837 4.246a1 1 0 01-1.415 0L7.354 3.177A.8.8 0 106.222 4.31l2.2 2.2a1 1 0 001.415 0l2.2-2.2a.8.8 0 10-1.132-1.132L9.837 4.246z","fill":"#F8F4EE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.13 0a.8.8 0 01.8.8v4.484a.8.8 0 11-1.6 0V.8a.8.8 0 01.8-.8z","fill":"#F8F4EE"}})])
          )
        }
      }
    